import React, { useState, useEffect } from "react";
import { oneKlicks } from "../../../SDK/oneclick";
import ImageShow from "../../../Uitiles/ImageShow";


const Articles = ({ data }) => {
    console.log('Articles data', data);
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchArticles();
    }, []);

    const fetchArticles = async () => {
        try {
            setLoading(true);
            setError(null);

            const tableSchema = '';
            const tableName = 'articles';
            const conditions = {
                doctor_id: data.id
            };
            const orderBy = 'id DESC';
            const search = '';
            const pagination = '';
            const margedata = [
                {
                    target_table: '	specialities',
                    target_column: 'id',
                    target_value: 'categories',
                    target_label: 'specialities'
                }
            ];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log('Articles response', response);
            if (response) {
                setArticles(response.data || []);
            } else {
                setArticles([]);
            }
        } catch (err) {
            console.error('Error fetching articles:', err);
            setError('Failed to load articles');
            setArticles([]);
        } finally {
            setLoading(false);
        }
    };


    return (

        <div className="tab-content dc-contentdoctab dc-haslayout ww">
            <div className="dc-location-holder tab-pane fade" id="locations">

            </div>

            <div className="dc-location-holder tab-pane fade active show" id="articles">
                <div className="dc-searchresult-holder">
                    <div className="dc-searchresult-head">
                        <div className="dc-title"><h4>Articles</h4></div>
                    </div>
                    <div className="">
                        <div className="dc-contentdoctab dc-articles-holder  dc-listedarticle">
                            <div className="dc-articles">
                                <div className="dc-articleslist-content dc-articles-list">
                                    {loading ? (
                                        // Loading State
                                        <div className="dc-article" style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            minHeight: 300,
                                            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                                            borderRadius: '12px',
                                            margin: '20px 0'
                                        }}>
                                            <div className="dc-articlecontent" style={{ textAlign: 'center' }}>
                                                <div style={{
                                                    position: 'relative',
                                                    display: 'inline-block',
                                                    marginBottom: '20px'
                                                }}>
                                                    {/* Modern animated loading spinner */}
                                                    <div style={{
                                                        width: '60px',
                                                        height: '60px',
                                                        border: '4px solid #e3f2fd',
                                                        borderTop: '4px solid #1976d2',
                                                        borderRadius: '50%',
                                                        animation: 'spin 1s linear infinite',
                                                        margin: '0 auto'
                                                    }}></div>

                                                    {/* Pulsing dots */}
                                                    <div style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '50%',
                                                        transform: 'translate(-50%, -50%)',
                                                        display: 'flex',
                                                        gap: '4px'
                                                    }}>
                                                        <div style={{
                                                            width: '6px',
                                                            height: '6px',
                                                            backgroundColor: '#1976d2',
                                                            borderRadius: '50%',
                                                            animation: 'pulse 1.4s ease-in-out infinite both',
                                                            animationDelay: '0s'
                                                        }}></div>
                                                        <div style={{
                                                            width: '6px',
                                                            height: '6px',
                                                            backgroundColor: '#1976d2',
                                                            borderRadius: '50%',
                                                            animation: 'pulse 1.4s ease-in-out infinite both',
                                                            animationDelay: '0.2s'
                                                        }}></div>
                                                        <div style={{
                                                            width: '6px',
                                                            height: '6px',
                                                            backgroundColor: '#1976d2',
                                                            borderRadius: '50%',
                                                            animation: 'pulse 1.4s ease-in-out infinite both',
                                                            animationDelay: '0.4s'
                                                        }}></div>
                                                    </div>
                                                </div>

                                                <h3 style={{
                                                    fontWeight: 600,
                                                    color: '#1976d2',
                                                    marginBottom: '8px',
                                                    fontSize: '18px'
                                                }}>
                                                    Loading Articles...
                                                </h3>

                                                <p style={{
                                                    color: '#666',
                                                    fontSize: '14px',
                                                    margin: 0
                                                }}>
                                                    Please wait while we fetch the latest articles
                                                </p>
                                            </div>
                                        </div>
                                    ) : error ? (
                                        // Error State
                                        <div className="dc-article" style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            minHeight: 300,
                                            background: 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)',
                                            borderRadius: '12px',
                                            margin: '20px 0'
                                        }}>
                                            <div className="dc-articlecontent" style={{ textAlign: 'center' }}>
                                                <div style={{
                                                    fontSize: '48px',
                                                    color: '#f44336',
                                                    marginBottom: '16px'
                                                }}>
                                                    ⚠️
                                                </div>
                                                <h3 style={{
                                                    fontWeight: 600,
                                                    color: '#d32f2f',
                                                    marginBottom: '8px',
                                                    fontSize: '18px'
                                                }}>
                                                    Oops! Something went wrong
                                                </h3>
                                                <p style={{
                                                    color: '#666',
                                                    fontSize: '14px',
                                                    marginBottom: '16px'
                                                }}>
                                                    {error}
                                                </p>
                                                <button
                                                    onClick={fetchArticles}
                                                    style={{
                                                        background: '#1976d2',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '10px 20px',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        transition: 'background 0.3s ease'
                                                    }}
                                                    onMouseOver={(e) => e.target.style.background = '#1565c0'}
                                                    onMouseOut={(e) => e.target.style.background = '#1976d2'}
                                                >
                                                    Try Again
                                                </button>
                                            </div>
                                        </div>
                                    ) : articles && articles.length > 0 ? (
                                        // Articles List
                                        articles.map((article) => (
                                            <div className="dc-article" key={article.id}>
                                                <figure className="dc-articleimg">
                                                    <ImageShow url={article.featured_image} width={250} height={195} />
                                                    <figcaption>
                                                        <div className="dc-articlesdocinfo" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                            <ImageShow url={data.profile_photo_url} width={30} height={30} />
                                                            <span style={{ fontSize: '14px', fontWeight: 'bold', maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{data.display_name || "Unknown Author"}</span>
                                                        </div>
                                                    </figcaption>
                                                </figure>
                                                <div className="dc-articlecontent">
                                                    <div className="dc-title">
                                                        <div className="dc-tag-v2">
                                                            <a
                                                                href={`/articles/${article.slug}/${article.id}`}
                                                                rel="tag"
                                                            >
                                                                {article.specialities[0].name || "Uncategorized"}
                                                            </a>
                                                        </div>
                                                        <h3>
                                                            <a href={`/articles/${article.slug}/${article.id}`}>
                                                                {article.title || "Untitled Article"}
                                                            </a>
                                                        </h3>
                                                        <span className="dc-datetime">
                                                            <i className="lnr lnr-clock"></i>{" "}
                                                            {article.created_at
                                                                ? new Date(article.created_at).toLocaleDateString()
                                                                : ""}
                                                        </span>
                                                    </div>
                                                    <div className="dc-optionarea">
                                                        <ul className="dc-moreoptions">
                                                            <li className="dcget-likes" data-key={article.id}>
                                                                <button type="button" className="dcget-likes-btn">
                                                                    <i className="ti-heart"></i>
                                                                    {article.likes || 0} Likes
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button type="button" className="dc-views-btn">
                                                                    <i className="ti-eye"></i>
                                                                    {article.views || 0} Views
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button type="button" className="dc-comments-btn">
                                                                    <i className="ti-comment"></i>
                                                                    {article.comments_count || 0} Comments
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        // Empty State
                                        <div className="dc-article" style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            minHeight: 300,
                                            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                            borderRadius: '12px',
                                            margin: '20px 0'
                                        }}>
                                            <div className="dc-articlecontent" style={{ textAlign: 'center' }}>
                                                <div style={{
                                                    fontSize: '64px',
                                                    color: '#6c757d',
                                                    marginBottom: '20px',
                                                    opacity: 0.7
                                                }}>
                                                    📝
                                                </div>
                                                <h3 style={{
                                                    fontWeight: 600,
                                                    color: '#495057',
                                                    marginBottom: '8px',
                                                    fontSize: '20px'
                                                }}>
                                                    No Articles Yet
                                                </h3>
                                                <p style={{
                                                    color: '#6c757d',
                                                    fontSize: '14px',
                                                    margin: 0,
                                                    maxWidth: '300px',
                                                    lineHeight: '1.5'
                                                }}>
                                                    This doctor hasn't published any articles yet. Check back later for medical insights and updates.
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>	</div>
            </div>
            {/* <div className="dc-shareprofile">
                <ul className="d-flex dc-tags-social">
                    <li className="dc-sharejob">Share Profile:</li>
                    <li className="dc-fb">
                        <a href="//www.facebook.com/sharer.php?u=https%3A%2F%2Fmeddylist.com%2Fdoctors%2Fflores-emily%2F" onclick="window.open(this.href, 'post-share','left=50,top=50,width=600,height=350,toolbar=0'); return false;">
                            <i className="fab fa-facebook-f"></i>
                        </a>
                    </li>
                    <li className="dc-twit">
                        <a href="//twitter.com/intent/tweet?text=Flores+Emily&amp;url=https%3A%2F%2Fmeddylist.com%2Fdoctors%2Fflores-emily%2F&amp;via=envato">
                            <i className="fab fa-twitter"></i>
                        </a>
                    </li>
                    <li className="dc-google-plus">
                        <a href="//plus.google.com/share?url=//css.meddylist.com//doctors/flores-emily/" onclick="window.open(this.href, 'post-share','left=50,top=50,width=600,height=350,toolbar=0'); return false;">
                            <i className="fab fa-google-plus-g"></i>
                        </a>
                    </li>
                    <li className="dc-instg">
                        <a href="//pinterest.com/pin/create/button/?url=//css.meddylist.com//doctors/flores-emily/&amp;media=//css.meddylist.com//wp-content/uploads/2019/09/asian-male-doctor-man-indian-wea-308x220.png&amp;description=Flores+Emily" onclick="window.open(this.href, 'post-share','left=50,top=50,width=600,height=350,toolbar=0'); return false;">
                            <i className="fab fa-pinterest-p"></i>
                        </a>
                    </li>
                </ul>
            </div> */}

            {/* CSS Animations */}
            <style>
                {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                    
                    @keyframes pulse {
                        0%, 80%, 100% {
                            transform: scale(0.8);
                            opacity: 0.5;
                        }
                        40% {
                            transform: scale(1);
                            opacity: 1;
                        }
                    }
                    
                    @keyframes fadeInUp {
                        0% {
                            opacity: 0;
                            transform: translateY(20px);
                        }
                        100% {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }
                    
                    @keyframes slideIn {
                        0% {
                            opacity: 0;
                            transform: translateY(30px);
                        }
                        100% {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }
                    
                    .dc-article {
                        animation: slideIn 0.6s ease-out;
                    }
                `}
            </style>
        </div>

    );
};

export default Articles;
